const promoPopup = document.querySelector(".popup-overlay");

if (promoPopup) {
  window.onload = (event) => {
    document.querySelector(".popup").style.display = "block";
    document.querySelector(".popup-overlay").style.display = "block";
  };
  document.querySelector(".popup-close").addEventListener(
    "click",
    function () {
      document.querySelector(".popup").style.display = "none";
      document.querySelector(".popup-overlay").style.display = "none";
    },
    false
  );
  document.querySelector("body").addEventListener(
    "click",
    function () {
      document.querySelector(".popup").style.display = "none";
      document.querySelector(".popup-overlay").style.display = "none";
    },
    false
  );
  document.querySelector(".popup").addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
    },
    false
  );
}
